import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import SectionHeading from './SectionHeading';
import { FAQ } from '../data/content';

export default function FaqSection() {
  return (
    <section id="faq" className="scroll-mt-24 py-24 md:py-32 bg-mist border-t border-line" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow="Questions" title="Straight answers." lead="If something is not covered here, write to us — a real person replies." />
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="divide-y divide-line rounded-3xl border border-line bg-white px-6">
            {FAQ.map((f, i) => (
              <AccordionItem key={i} value={`q-${i}`} className="border-0" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-display text-left text-base md:text-lg font-semibold text-navy hover:no-underline py-5">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm md:text-[15px] text-slate-600 leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
